import React from 'react';
import {
  HeroBanner,
  HeroBannerProps,
  TextColorMode,
} from '@noths/polaris-client-ribbons-design-system';

import { BlockContainer } from '../BlockContainer';
import * as styles from './HeroBannerBlock.style';

export const HeroBannerBlock = (props: HeroBannerProps) => (
  <BlockContainer wrapperStyles={styles.wrapper}>
    <HeroBanner {...props} />
  </BlockContainer>
);

export type { HeroBannerProps, TextColorMode };
